module.exports = __webpack_public_path__ + "static/article-3-81491b64e240f628ad6cf1d86d288244.png";